import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Row,
  message,
  InputNumber,
  Dropdown,
  Space,
  Switch,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createPackage, getPlans } from "../../redux/Packages/PackagesActions";
import { useLocation } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { getFeatures } from "../../redux/Features/FeaturesActions";

const CreatePackage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const plans = useSelector((state) => state.PackagesReducer.plans);
  const userData = useSelector((state) => state.Auth.userData);
  const getFeaturesData = useSelector(
    (state) => state.FeaturesReducer.getFeaturesData
  );

  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [activePermissions, setActivePermissions] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  useEffect(() => {
    dispatch(getPlans({ _id: userData?._id }));
    dispatch(getFeatures({ _id: userData?._id }));
  }, []);

  useEffect(() => {
    const permissions = getFeaturesData?.filter(
      (permissions) => permissions.status === true
    );
    setActivePermissions(permissions);
  }, [getFeaturesData]);

  const submitHandler = (values) => {
    const data = {
      _id: userData?._id,
      planTypeId: selectedPlan?._id,
      packageSku: values.packageSku,
      packageTitle: values.packageTitle,
      subTitle: values.subTitle,
      shortDesc: values.shortDesc,
      packagePrice: values.packagePrice,
      brandCount: values.brandCount,
      packageDuration: values.packageDuration,
      userCount: values.userCount,
      packageStatus: checked,
      packageDescription: values.packageDescription,
      permissions: selectedPermissions,
    };

    dispatch(createPackage(data, navigateAfterSuccess));
  };

  const navigateAfterSuccess = () => {
    message.success("Successfully Created");
    navigate("/packages", { state: { data: location?.state?.data } });
  };

  const handleMenuClick = (e) => {
    const plan = plans.find((plan) => plan._id === e.key);
    message.info(`Selected plan: ${plan.title}`);
    setSelectedPlan(plan);
    form.setFieldsValue({ planTypeId: plan._id });
  };

  const items = plans.map((plan) => ({
    label: plan.title,
    key: plan._id,
  }));

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const handleChange = (value) => {
    setSelectedPermissions(value);
  };

  const optionsPermission =
    activePermissions?.map((item) => ({
      label: item.title,
      value: item._id,
    })) || [];

  return (
    <>
      <Breadcrumb
        className="breadCrumb"
        items={[
          { title: "Plans & Packages" },
          { title: "Packages" },
          { title: "Create Package" },
        ]}
      />
      <Row className="addShortcut">
        <Col span={24}>
          <div>
            <Form
              form={form}
              name="control-hooks"
              labelCol={{ span: 4 }}
              layout="horizontal"
              className="ticketForm"
              onFinish={submitHandler}
            >
              <Form.Item wrapperCol={{ span: 8 }} label="Plan">
                <Dropdown menu={menuProps}>
                  <Button>
                    <Space>
                      {selectedPlan ? selectedPlan.title : "Select Plan"}
                      <DownOutlined />
                    </Space>
                  </Button>
                </Dropdown>
              </Form.Item>
              <Form.Item
                name="packageSku"
                wrapperCol={{ span: 8 }}
                label="Package SKU"
                rules={[
                  {
                    required: true,
                    message: "Please enter SKU",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="packageTitle"
                wrapperCol={{ span: 8 }}
                label="Package Title"
                rules={[
                  {
                    required: true,
                    message: "Please enter package title!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="subTitle"
                wrapperCol={{ span: 8 }}
                label="Sub Title"
                rules={[
                  {
                    required: true,
                    message: "Please enter sub title!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="shortDesc"
                wrapperCol={{ span: 8 }}
                label="Short Description"
                rules={[
                  {
                    required: true,
                    message: "Please enter package short description!",
                  },
                ]}
              >
                <TextArea rows={3} />
              </Form.Item>
              <Form.Item
                name="packagePrice"
                wrapperCol={{ span: 8 }}
                label="Price"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter a valid price!",
                  },
                  {
                    type: "number",
                    min: 1,
                    message: "Price must be greater than 0!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                name="brandCount"
                wrapperCol={{ span: 8 }}
                label="Brands (No. of brands)"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter package brands count!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                name="packageDuration"
                wrapperCol={{ span: 8 }}
                label="Duration (In Days)"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter package duration!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item
                name="userCount"
                wrapperCol={{ span: 8 }}
                label="Users (No. of users)"
                rules={[
                  {
                    required: true,
                    type: "number",
                    message: "Please enter package users count!",
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
              <Form.Item wrapperCol={{ span: 8 }} label="Package Status">
                <Switch
                  checked={checked}
                  onChange={(value) => setChecked(value)}
                />
              </Form.Item>

              <Form.Item
                name="packageDescription"
                wrapperCol={{ span: 8 }}
                label="Description"
                rules={[
                  {
                    required: true,
                    message: "Please enter package description!",
                  },
                ]}
              >
                <TextArea rows={3} />
              </Form.Item>

              <Form.Item
                name="permissions"
                wrapperCol={{ span: 8 }}
                label="Permissions"
              >
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: "100%" }}
                  placeholder="Please select permissions"
                  value={selectedPermissions}
                  onChange={handleChange}
                  options={optionsPermission}
                />
              </Form.Item>              

              <div className="topbtn">
                <Button
                  className="back-btn"
                  onClick={() =>
                    navigate("/packages", {
                      state: { data: location?.state?.data },
                    })
                  }
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  className="align-right"
                  htmlType="submit"
                >
                  Save
                </Button>
              </div>
            </Form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default CreatePackage;
